import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container } from "../styles/styles";
import {
  PrimaryColor,
  SecondaryColor,
  TextColor,
  TextColorLight,
  BackgroundColor,
  BackgroundColorLight,
  Accent,
  ErrorComponent,
  Border,
  Green,
  Blue,
} from "../styles/global";
import { BackBar } from "../styles/global";
import { ContentSection, Content } from "../styles/styles";
import { toast } from "react-toastify";

import breakpoints from "../styles/breakpoints";

import { SvgUser } from "../assets/icons";
import coin1 from "../assets/icons/moeda-1.svg";
import coin5 from "../assets/icons/moeda-5.svg";
import coin10 from "../assets/icons/moeda-10.svg";
import coin50 from "../assets/icons/moeda-50.svg";
import coin100 from "../assets/icons/moeda-100.svg";
import { FaRegUserCircle } from "react-icons/fa";
import logo from "../assets/icons/logo-banco-da-felicidade.svg";
import { FiXCircle } from "react-icons/fi";
import { styles } from "../pages/home/styles";
import { getUserData, getUserHistory } from "../controllers/userController";

const Header = styled.header`
  background: linear-gradient(185deg, ${Blue} 28%, ${Green} 0%);
  color: white;
  padding: 14px;
  padding-bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 18px;

  .headerText {
    margin-top: 18px;
    text-align: center;
    font-size: 18px;
    font-weight: normal;
  }
`;

const BackButton = styled.a`
  margin-top: 22px;
  display: flex;
  align-items: center;
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  width: fit-content;
`;

const Employee = styled(Container)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 30px;

  .employee-name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 10px;
    text-align: left;

    h4 {
      color: #000;
      font-size: 14px;
      font-weight: 300;
    }
  }

  .employee-details {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 0px;
    flex: 1;
    text-align: left;
    p,
    small {
      color: #000;
      font-size: 14px;
      width: max-content;
    }

    p {
      font-weight: 500;
    }
    small {
      font-weight: lighter;
    }
  }

  .employee-icon-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: ${Border};
    text-align: center;
    padding: 10px;
  }
  .employee-icon {
    font-size: 25px;
    color: #444;
  }
`;

const MoedasTypeSelector = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
  padding: 0 20px;
  
  .selector-container {
    display: flex;
    background: #f0f0f0;
    border-radius: 25px;
    padding: 4px;
    width: 100%;
    max-width: 400px;
    border: 1px solid #e0e0e0;
  }
  
  .selector-btn {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    border-radius: 21px;
    transition: all 0.3s ease;
    flex: 1;
    text-align: center;
    
    &.active {
      background: #4CAF50;
      color: white;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    &.inactive {
      background: transparent;
      color: #666;
    }
  }
`;

const Caption = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin-top: 20px;

  > p {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    color: #444;
  }
`;

const CoinSelection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

const CoinItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  border: 1px solid ${Border};
  border-radius: 25px;
  position: relative;
  padding: 10px 15px 10px 35px;

  img {
    position: absolute;
    left: -20px;
    width: 50px;
  }

  p {
    color: #444;
    text-align: center;
    min-width: 40px;
  }

  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  div span {
    font-size: 16px;
    color: #444;
    text-align: center;
    min-width: 30px;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    padding: 8px 12px 8px 30px;
  }
`;

const CoinButton = styled.button`
  background: none;
  color: #444;
  border: none;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background: none !important;
  }
  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

const Amount = styled.span`
  color: ${PrimaryColor};
  font-size: 18px;
  font-weight: 400;
  text-align: start;
`;

const ContinueButton = styled.button`
  background-color: ${Green};
  padding: 10px 70px;
  border-radius: 30px;
  border: none;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 10px;
`;

function SelecionarMoedas({
  emocionador,
  onConfirm,
  onBack,
  onClose,
  errorMessage,
  moedasType,
  setMoedasType,
  isGestor,
}) {
  const [selectedMoedas, setSelectedMoedas] = useState({
    1: 0,
    5: 0,
    10: 0,
    50: 0,
    100: 0,
  });
  const [moedasDistribuidas, setMoedasDistribuidas] = useState({});
  const [userData, setUserData] = useState({});
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user")) || {};

      const handleTypeChange = (newType) => {
      setMoedasType(newType);
      // Limpa a seleção atual para evitar o bug
      setSelectedMoedas({
        1: 0,
        5: 0,
        10: 0,
        50: 0,
        100: 0,
      });
    };

    const handleMoedaChange = (value, amount) => {
      const newAmount = Math.max(0, selectedMoedas[value] + amount);
      const newSelectedMoedas = {
        ...selectedMoedas,
        [value]: newAmount
      };

      // Se não for admin (nivel 1), verificar se está tentando selecionar mais de uma moeda
      if (user.nivel !== 1) {
        const totalCoinsSelected = Object.values(newSelectedMoedas).reduce((total, qty) => total + qty, 0);
        
        // Se está tentando selecionar mais de uma moeda total, bloquear
        if (totalCoinsSelected > 1) {
          return; // Não permite a alteração
        }
      }

    setSelectedMoedas(newSelectedMoedas);
  };

  const totalMoedas = Object.keys(selectedMoedas).reduce((total, value) => {
    return total + selectedMoedas[value] * parseInt(value);
  }, 0);

  const canContinue = Object.values(selectedMoedas).some(
    (amount) => amount > 0
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (user?.idusuario) {
          const userInfo = await getUserData(user.idusuario);
          setUserData(userInfo || {});
          
          // Parse do JSON moedas_a_distribuir
          const moedasData = JSON.parse(userInfo?.moedas_a_distribuir || "{}");
          
          let moedasParaExibir = {};

          // Verifica se o JSON tem a estrutura nova (com as chaves de carteira)
          if (moedasData['Moedas Minha Equipe'] || moedasData['Moedas Outras Unidades']) {
          
            moedasParaExibir = moedasData[moedasType] || {};

          } else {
            moedasParaExibir = moedasData;
          }
          
          setMoedasDistribuidas(moedasParaExibir);

          const userHistory = await getUserHistory(user.idusuario);
          setHistory(userHistory || []);
        }
      } catch (error) {
        toast.error("Erro ao carregar dados do usuário. Tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user?.idusuario, moedasType]);

  // Determina qual conjunto de moedas usar baseado no tipo selecionado
  const moedasDisponiveis = moedasDistribuidas;

  // Se não tem emocionador, mostre mensagem
  if (!emocionador) {
    return (
      <Container direction="column" width="100%">
        <ContentSection fullWidth padding="10px">
          <Content padding="20px" style={{ textAlign: 'center' }}>
            <p>Nenhum emocionador selecionado.</p>
          </Content>
        </ContentSection>
      </Container>
    );
  }

  // LOADING STATE
  if (loading) {
    return (
      <Container direction="column" width="100%">
        <ContentSection fullWidth padding="10px">
          <Content padding="20px" style={{ textAlign: 'center' }}>
            <p>Carregando dados...</p>
          </Content>
        </ContentSection>
      </Container>
    );
  }

  return (
    <>
      <Header>
        <h1 className="headerText">Emocionar</h1>
        <BackButton onClick={onClose}>
          <FiXCircle />
        </BackButton>
      </Header>
      <Container direction="column" width="100%" padding="10px">
        <ContentSection fullWidth>
          <Content bgColor={Accent} align="center" gap="30px">
            <Employee fullWidth padding="0px">
              <div className="employee-name">
                <div className="employee-icon-div">
                  <FaRegUserCircle className="employee-icon" />
                </div>
                <h4>{emocionador.nome}</h4>
              </div>
              <div className="employee-details">
                <p>{emocionador.unidade}</p>
                <small>{emocionador.setor}</small>
              </div>
            </Employee>

            {isGestor && (  
              <MoedasTypeSelector>
                <div className="selector-container">
                  <button
                    className={moedasType === 'Moedas Minha Equipe' ? 'selector-btn active' : 'selector-btn inactive'}
                    onClick={() => handleTypeChange('Moedas Minha Equipe')} 
                  >
                    Moedas Minha Equipe
                  </button>
                  <button
                    className={moedasType === 'Moedas Outras Unidades' ? 'selector-btn active' : 'selector-btn inactive'}
                    onClick={() => handleTypeChange('Moedas Outras Unidades')} 
                  >
                    Moedas Outras Unidades
                  </button>
                </div>
              </MoedasTypeSelector>
            )}

            {/* Exibição das moedas disponíveis */}
            {user.nivel != 0 && (
              <>
                {user.nivel === 1 ? (
                  <div style={styles.moedasSection}>
                    <p style={styles.sectionTitle}>Moedas para distribuir:</p>
                    <div style={styles.moedasContainer}>
                      <p
                        style={{
                          color: "black",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%", 
                        }}
                      >
                        Ilimitado
                      </p>
                    </div>
                  </div>
                ) : (
                  <div style={styles.moedasSection}>
                    <p style={styles.sectionTitle}>
                      Moedas {moedasType === 'Moedas Minha Equipe' ? 'Moedas Minha Equipe' : 'Moedas Outras Unidades'} para emocionar:
                    </p>
                    <div style={styles.moedasContainer}>
                      <div style={styles.moedaItem}>
                        <img src={coin1} alt="1 Moeda" style={styles.moedaIcon} />
                        <p style={styles.moedaText}>{moedasDistribuidas["1"] || 0}</p>
                      </div>
                      <div style={styles.moedaItem}>
                        <img src={coin5} alt="5 Moedas" style={styles.moedaIcon} />
                        <p style={styles.moedaText}>{moedasDistribuidas["5"] || 0}</p>
                      </div>
                      <div style={styles.moedaItem}>
                        <img src={coin10} alt="10 Moedas" style={styles.moedaIcon} />
                        <p style={styles.moedaText}>{moedasDistribuidas["10"] || 0}</p>
                      </div>
                      <div style={styles.moedaItem}>
                        <img src={coin50} alt="50 Moedas" style={styles.moedaIcon} />
                        <p style={styles.moedaText}>{moedasDistribuidas["50"] || 0}</p>
                      </div>
                      <div style={styles.moedaItem}>
                        <img src={coin100} alt="100 Moedas" style={styles.moedaIcon} />
                        <p style={styles.moedaText}>{moedasDistribuidas["100"] || 0}</p>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            <CoinSelection>
              {Object.entries(selectedMoedas).map(([value, amount]) => {
                const saldoMoeda = moedasDisponiveis[value] || 0;

                return (
                  <CoinItem key={value}>
                    <img
                      src={
                        value === "1"
                          ? coin1
                          : value === "5"
                          ? coin5
                          : value === "10"
                          ? coin10
                          : value === "50"
                          ? coin50
                          : coin100
                      }
                      alt={`${value} Moedas`}
                    />
                    <p></p>
                    <div>
                      <CoinButton
                        onClick={() => handleMoedaChange(value, -1)}
                        disabled={user.nivel !== 1 && amount <= 0}
                      >
                        -
                      </CoinButton>
                      <span>{amount}</span>
                      <CoinButton
                        onClick={() => handleMoedaChange(value, +1)}
                        disabled={
                          user.nivel !== 1 && (
                            amount >= saldoMoeda || 
                            (Object.values(selectedMoedas).reduce((total, qty) => total + qty, 0) >= 1 && amount === 0)
                          )
                        }
                      >
                        +
                      </CoinButton>
                    </div>
                  </CoinItem>
                );
              })}
            </CoinSelection>

            {errorMessage && (
              <ErrorComponent message={errorMessage} duration={8000} />
            )}
            <ContinueButton
              onClick={() => onConfirm(selectedMoedas)}
              disabled={!canContinue}
            >
              Continuar
            </ContinueButton>
          </Content>
        </ContentSection>
      </Container>
    </>
  );
}

export default SelecionarMoedas;